export default __webpack_public_path__ + "static/media/line.09973f85.svg";